
<template>
    <div>
        <creator-video-index-items :key="$route?.params?.slug" />
    </div>
</template>



<script>
import CreatorVideoIndexItems from "@/components/creatorVideo/CreatorVideoIndexItems";

export default {
    components: {
        CreatorVideoIndexItems,
    },
};
</script>
